import { render, staticRenderFns } from "./SmsIncomingTariffs.vue?vue&type=template&id=48a012e1&"
import script from "./SmsIncomingTariffs.vue?vue&type=script&lang=ts&"
export * from "./SmsIncomingTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports